import Manager from "../../src/manager";
import React from "react";

function Mapper(data, status, response, error, component) {
	let output = [];
	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		id: {
			alias: "id",
			type: "text",
			editable,
		},
		period: {
			alias: "period",
			type: "text",
			editable: false,
		},
		periodMeasunit: {
			alias: "periodMeasunit",
			type: "text",
			editable: false,
		},
		tariff: {
			alias: "tariff",
			type: "text",
			editable,
		},
		teaser: {
			alias: "teaser",
			type: "text",
			editable,
		},
		confirm: {
			alias: "confirm",
			type: "button",
			caption: "Επιβεβαίωση",
			events: {
				onClick: function () {
					window.location.replace("/");
				},
			},
			editable,
		},
	};
}

const ModalForTermVat = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					data: [{}],
					replace: {},
					mapper: Mapper,
				},
			},
			template: "plain",
			templateConfiguration: {
				cardTopTemplate: function () {
					const closeModal = () => {
						window["modal"].setState({ show: false });
						document.getElementById("body").classList.remove("locked");
					};

					return (
						<div
							className="lightbox"
							id="termvat"
							style={{ display: "block" }}>
							<div className="content">
								<a
									className="cancel addCursorPointer"
									onClick={closeModal}></a>
								<h2>Τέλος Συνδρομητών Κινητής Τηλεφωνίας</h2>
								<div
									className="text scroll-content jspScrollable"
									tabIndex="0">
									<div className="ans">
										<p>
											Στις τιμές των πακέτων εφαρμόζεται Τέλος Συνδρομητών
											Κινητής Τηλεφωνίας 10% επί του μηνιαίου λογαριασμού κάθε
											σύνδεσης προ ΦΠΑ και Τέλος Κινητής Τηλεφωνίας δέκα τοις
											εκατό (10%) επί της αξίας του χρηματικού υπολοίπου προ
											Φ.Π.Α.
										</p>
										<p>
											Στα προγράμματα Mobile Internet δεν επιβάλλεται Τέλος
											Συνδρομητών Κινητής Τηλεφωνίας επί του παγίου και της
											χρήσης Internet. Για τα συγκεκριμένα προγράμματα το Τέλος
											Συνδρομητών Κινητής Τηλεφωνίας θα επιβάλλεται μόνο στις
											περιπτώσεις που γίνει χρήση των υπηρεσιών SMS, GPRS WAP,
											DATA/FAX καθώς και υπηρεσιών πολυμεσικής πληροφόρησης.
											Εξαιρούνται τα προγράμματα Mobile Internet AnyWay στα
											οποία επιβάλλεται Τέλος Συνδρομητών Κινητής Τηλεφωνίας επί
											του παγίου και της χρήσης Internet.
										</p>
										<p>
											Το Τέλος Συνδρομητών Κινητής και Καρτοκινητής Τηλεφωνίας{" "}
											<b>
												είναι μηδενικό (0%) για φυσικά πρόσωπα ηλικίας δεκαπέντε
												(15) έως και είκοσι εννέα (29) ετών, δηλαδή πρόσωπα που
												κατά τη διάρκεια κάθε έτους έχουν συμπληρώσει το δέκατο
												τέταρτο (14ο) έτος της ηλικίας τους έως την 31η
												Δεκεμβρίου του προηγουμένου έτους και δεν έχουν
												συμπληρώσει το τριακοστό (30ο) έτος της ηλικίας τους έως
												την ημερομηνία αυτή.
											</b>
										</p>
										<p>
											Για την εφαρμογή του μηδενικού συντελεστή απαιτείται
											εγγραφή σε ειδική εφαρμογή προσβάσιμη μέσω της ενιαίας
											ψηφιακής πύλης της δημόσιας διοίκησης (gov.gr-ΕΨΠ).
										</p>
										<p>
											Ο μηδενικός συντελεστής εφαρμόζεται για μία (1) σύνδεση ή
											ένα (1) καρτοκινητό ανά δικαιούχο, μετά την ολοκλήρωση της
											εγγραφής στην εφαρμογή των δικαιούχων ή των εχόντων την
											επιμέλειά τους σε περίπτωση ανηλίκων, από την πρώτη
											τιμολόγηση σε περίπτωση σύνδεσης συμβολαίου ή από την
											επόμενη ανανέωση χρηματικού υπολοίπου σε περίπτωση
											σύνδεσης καρτοκινητής.
										</p>
										<p>
											Ο συντελεστής 10% καταλαμβάνει λογαριασμούς που εκδίδονται
											και κάρτες χρόνου ομιλίας ή επικοινωνίας και ανανεώσεις
											που ενεργοποιούνται από τους καταναλωτές από την
											01/01/2022 και μετά.
										</p>
										<p>
											Ο μηδενικός συντελεστής εφαρμόζεται σε λογαριασμούς που
											εκδίδονται και κάρτες χρηματικού υπολοίπου ή επικοινωνίας
											και ανανεώσεις που ενεργοποιούνται από τους καταναλωτές
											από την 01/01/2022 και μετά, και σύμφωνα με όσα
											αναφέρονται ανωτέρω.
										</p>
									</div>
								</div>
								<div className="clear"></div>
							</div>
						</div>
					);
				},
				includeProperties: ["none"],
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default ModalForTermVat;
